import { AgentsProofreaderIcon, Icon, type IconProps } from '@grammarly/design-system'

type ProofreaderAgentIconProps = {
  accessibilityLabel?: string
  size: IconProps['size']
}

export const ProofreaderAgentIcon = ({ size, accessibilityLabel }: ProofreaderAgentIconProps) => {
  return (
    <Icon
      size={size}
      icon={AgentsProofreaderIcon}
      accessibilityLabel={accessibilityLabel ?? 'Grammarly Proofreader'}
    />
  )
}
